module.exports = __webpack_public_path__ + "img/handen.52fe67d6.jpg";